import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider, useApp } from "./contexts/AppContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout/Layout";
import Dashboard from "./components/Dashboard/Dashboard";
import StudyLibrary from "./components/Study/StudyLibrary";
import Quizzes from "./components/Quiz/Quizzes";
import ExamMode from "./components/Exam/ExamMode";
import LandingPage from "./components/Landing/LandingPage";
import ProfileModal from "./components/Auth/ProfileModal";
import LoginModal from "./components/Auth/LoginModal";
import RegisterModal from "./components/Auth/RegisterModal";
import BillingPage from "./components/Billing/BillingPage";
import LegalPage from "./components/Landing/LegalPage";
import ForgotPasswordModal from "./components/Auth/ForgotPasswordModal";
import UpdatePasswordPage from "./components/Auth/UpdatePasswordPage"; // Asegúrate de tener este componente

const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();
  const { view, setView, currentExam, isPremium } = useApp();

  const [showProfile, setShowProfile] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showForgot, setShowForgot] = useState(false); // Estado para el modal de recuperar

  useEffect(() => {
    // Al montar la app, reseteamos la posición del scroll al tope
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center bg-white">
        <div className="w-12 h-12 border-4 border-slate-100 border-t-blue-600 rounded-full animate-spin" />
        <p className="mt-4 text-slate-400 font-bold text-xs uppercase tracking-widest animate-pulse">
          Cargando...
        </p>
      </div>
    );
  }

  const renderMainContent = () => {
    if (!isAuthenticated) {
      return (
        <div className="min-h-screen w-full overflow-x-hidden bg-white">
          <LandingPage
            onLoginClick={() => setShowLogin(true)}
            onRegisterClick={() => setShowRegister(true)}
          />
          <LoginModal
            isOpen={showLogin}
            onClose={() => setShowLogin(false)}
            onSwitchToRegister={() => {
              setShowLogin(false);
              setShowRegister(true);
            }}
            onForgotPassword={() => {
              setShowLogin(false);
              setShowForgot(true);
            }}
          />
          <RegisterModal
            isOpen={showRegister}
            onClose={() => setShowRegister(false)}
            onSwitchToLogin={() => {
              setShowRegister(false);
              setShowLogin(true);
            }}
          />
          <ForgotPasswordModal
            isOpen={showForgot}
            onClose={() => setShowForgot(false)}
          />
        </div>
      );
    }

    const renderView = () => {
      if (view === "exam" && currentExam) return <ExamMode />;
      switch (view) {
        case "dashboard":
          return <Dashboard />;
        case "study":
          return <StudyLibrary />;
        case "quizzes":
          return <Quizzes />;
        case "billing":
          return <BillingPage />;
        default:
          return <Dashboard />;
      }
    };

    return (
      <div className="min-h-screen w-full flex flex-col overflow-x-hidden bg-slate-50">
        <Layout setShowProfile={setShowProfile}>
          <main className="flex-grow w-full max-w-full overflow-x-hidden">
            {renderView()}
          </main>
        </Layout>
        <ProfileModal
          isOpen={showProfile}
          onClose={() => setShowProfile(false)}
        />
      </div>
    );
  };

  return (
    <Routes>
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/update-password" element={<UpdatePasswordPage />} />
      <Route path="*" element={renderMainContent()} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <Router>
          <AppContent />
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
